import { render, staticRenderFns } from "./SnackbarNotification.vue?vue&type=template&id=6ce8ef30&scoped=true"
import script from "./SnackbarNotification.vue?vue&type=script&lang=js"
export * from "./SnackbarNotification.vue?vue&type=script&lang=js"
import style0 from "./SnackbarNotification.vue?vue&type=style&index=0&id=6ce8ef30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce8ef30",
  null
  
)

export default component.exports